import { render } from "./TableInsights.vue?vue&type=template&id=48edef1e&scoped=true"
import script from "./TableInsights.vue?vue&type=script&lang=js"
export * from "./TableInsights.vue?vue&type=script&lang=js"

import "./TableInsights.vue?vue&type=style&index=0&id=48edef1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48edef1e"]])

export default __exports__